import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import AuditedSalesReport from "./components/auditedSalesReport";
import ViewRecordings from "./components/viewRecordings";
import AgentSalesReport from "./components/agentSalesReport";
import NavbarLayout from "./components/Navbar";
import Enrollment from "./components/enrollment";
import AgentNpn from "./components/insuranceAgentNpn";
import TaxwiseScript from "./components/taxWiseScript.js";
import ChatHistory from "./components/smsChatHistory.js";
import Unauthorized from "./components/unauthorizedPage.js";
import TaxReport from "./components/taxReport.js";
import WebsiteChat from "./components/websiteChatBox.js";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SecondaryChatHistory from "./components/SecondaryChatHistory.js";

// Utility function to read a cookie by name
function getCookie(name) {
  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((row) => row.startsWith(`${name}=`));
  return cookie ? cookie.split("=")[1] : null;
}

// Create a new component to handle conditional header rendering
function AppContent() {
  const location = useLocation(); // Get the current location
  const sessionId = getCookie("ASP.NET_SessionId"); // Get session ID from cookies

  // // Redirect to the unauthorized page if the session ID is missing
  // if (!sessionId) {
  //   <Navigate to="/unauthorized" replace />;
  // }

  return (
    <div className="App">
      {location.pathname !== "/agentOptions" &&
        location.pathname !== "/enrollment" &&
        location.pathname !== "/agentNpn" &&
        !location.pathname.startsWith("/taxwise/") &&
        !location.pathname.startsWith("/chatHistory/") &&
        !location.pathname.startsWith("/secondary/chatHistory/") &&
        !location.pathname.startsWith("/webChat/") && (
          // !location.pathname.startsWith("/unauthorized/") &&
          <h1>ROCKET MULTISERVICES REPORTS</h1>
        )}

      <Routes>
        <Route path="/agentSalesReports" element={<AgentSalesReport />} />
        <Route path="/TaxReport" element={<TaxReport />} />
        <Route path="/auditedSalesReports" element={<AuditedSalesReport />} />
        <Route path="/callRecordings" element={<ViewRecordings />} />
        <Route path="/agentOptions" element={<NavbarLayout />} />
        <Route path="/enrollment" element={<Enrollment />} />
        <Route path="/webChat/:officeName" element={<WebsiteChat />} />
        <Route path="/agentNpn" element={<AgentNpn />} />
        <Route
          path="/taxwise/:login/:phoneNumber/:officeName/:serviceId/:contactId/:UCID"
          element={<TaxwiseScript />}
        />
        <Route path="/chatHistory/:phoneNumber" element={<ChatHistory />} />
        <Route
          path="/secondary/chatHistory/:phoneNumber"
          element={<SecondaryChatHistory />}
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename="/rms-cctools-ui">
      <AppContent /> {/* Main content is inside the BrowserRouter */}
      <ToastContainer position="top-right" autoClose={5000} />
    </BrowserRouter>
  );
}

export default App;
